import React, { Component } from 'react'
import { compose } from 'react-apollo'
import { injectGlobal } from 'styled-components'
import { Switch, Route, withRouter } from 'react-router'
import { ThemeProvider } from 'styled-components'
import { injectLayoutBaseCSS, GridThemeProvider } from 'styled-bootstrap-grid'

import GridView from 'ui/components/generic/GridView'
import MediaProvider from 'redux/modules/media/MediaProvider'
import withSiteMeta from 'containers/withSiteMeta'
import theme from 'ui/styles/theme'
import global from 'ui/styles/global'
import AnimatedRoutes from 'ui/components/AnimatedRoutes'
import Navigation from 'ui/components/Navigation'
import Page from 'ui/components/Page'
import Background from 'ui/components/Background'
import Loading from 'ui/components/generic/Loading'

class App extends Component {
  render() {
    // Apply bootstrap global styling
    injectLayoutBaseCSS()

    // Apply custom global styling
    injectGlobal`${global}`

    const { location, match, siteMetaLoading } = this.props

    if (siteMetaLoading) {
      return <Loading />
    }

    return (
      <ThemeProvider theme={theme}>
        <GridThemeProvider gridTheme={theme.grid}>
          <MediaProvider>
            <Navigation />
            <AnimatedRoutes pathname={location.pathname}>
              <Switch location={location}>
                <Route
                  exact
                  path={`/:language(${process.env.REACT_APP_LOCALE_REGEX})?/`}
                  render={props => (
                    <Page type="page" key={match.url} {...props} />
                  )}
                />
                <Route
                  exact
                  path={`/:language(${process.env.REACT_APP_LOCALE_REGEX})?/:slug`}
                  render={props => (
                    <Page type="page" key={match.url} {...props} />
                  )}
                />
                <Route
                  exact
                  path={`/:language(${process.env.REACT_APP_LOCALE_REGEX})?/tour-dates/:slug`}
                  render={props => (
                    <Page type="concert" key={match.url} {...props} />
                  )}
                />
                <Route
                  exact
                  path={`/:language(${process.env.REACT_APP_LOCALE_REGEX})?/setups/:slug`}
                  render={props => (
                    <Page type="setup" key={match.url} {...props} />
                  )}
                />
              </Switch>
            </AnimatedRoutes>
            <Background />
            {process.env.NODE_ENV === 'development' && <GridView />}
          </MediaProvider>
        </GridThemeProvider>
      </ThemeProvider>
    )
  }
}

export default compose(withSiteMeta(), withRouter)(App)



// WEBPACK FOOTER //
// ./src/App.js